import styled from 'styled-components';

export const TableToolsContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;
